(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["clothing-pdp-buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(initClothingBuyButtons);
  });

  function initClothingBuyButtons(root) {
    var atcBtn = root.querySelector('[data-atc-trigger]');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    var notifyMount = root.querySelector('[data-notify-mount]');
    if (!atcBtn) return;

    root.addEventListener('clothing-pdp:variant-change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;
      atcBtn.dataset.variantId = variant.id;
      var sticky = root.querySelector('[data-sticky-atc]');
      if (sticky) sticky.dataset.variantId = variant.id;

      [atcBtn, sticky].forEach(function (btn) {
        if (!btn) return;
        if (variant.available) {
          btn.disabled = false;
          btn.textContent = btn.textContent.trim() === 'Adding...' ? btn.textContent : 'Add to bag';
        } else {
          btn.disabled = true;
          btn.textContent = 'Sold out';
        }
      });

      if (buyNowBtn) {
        buyNowBtn.style.display = variant.available ? '' : 'none';
        buyNowBtn.href = root.dataset.cartUrl + '/' + variant.id + ':1';
      }

      if (notifyMount) {
        notifyMount.classList.toggle('is-hidden', variant.available);
      }
    });

    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled) return;

      if (root.dataset.sizeRequired === 'true' && root.dataset.sizeSelected !== 'true') {
        if (window.clothingPdpFlagSizeError) window.clothingPdpFlagSizeError(root);
        return;
      }

      var sticky = root.querySelector('[data-sticky-atc]');
      var variantId = atcBtn.dataset.variantId;
      var originalText = atcBtn.textContent;
      var stickyOriginalText = sticky ? sticky.textContent : null;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';
      if (sticky) {
        sticky.disabled = true;
        sticky.textContent = 'Adding...';
      }

      window.clothingPdpAddToCartAjax(root, [{ id: variantId, quantity: 1 }]).finally(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = originalText === 'Adding...' ? 'Add to bag' : originalText;
        if (sticky) {
          sticky.disabled = false;
          sticky.textContent = stickyOriginalText === 'Adding...' ? 'Add to bag' : stickyOriginalText;
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-delivery-check"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-delivery-check]').forEach(initClothingDeliveryCheck);
  });

  function initClothingDeliveryCheck(root) {
    var input = root.querySelector('[data-pincode-input]');
    var button = root.querySelector('[data-pincode-check]');
    var result = root.querySelector('[data-pincode-result]');
    var datasetUrl = root.dataset.datasetUrl;
    if (!input || !button || !result) return;

    var savedCode = null;
    try {
      savedCode = window.localStorage.getItem('clothingPdpPincode');
    } catch (e) {}
    if (savedCode) input.value = savedCode;

    function showResult(message, state) {
      result.textContent = message;
      result.hidden = false;
      result.classList.remove('is-success', 'is-error');
      if (state) result.classList.add(state);
    }

    button.addEventListener('click', function () {
      var code = input.value.trim();
      if (!/^\d{6}$/.test(code)) {
        showResult('Please enter a valid 6-digit pincode!', 'is-error');
        return;
      }

      fetch(datasetUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var found = Array.isArray(data) && data.some(function (row) {
            return String(row['Postal code']) === code;
          });
          if (found) {
            try { window.localStorage.setItem('clothingPdpPincode', code); } catch (e) {}
            showResult('Estimated Delivery Time: 3-5 Days', 'is-success');
          } else {
            showResult('Sorry, this pincode is not serviceable!', 'is-error');
          }
        })
        .catch(function () {
          showResult('Could not check serviceability right now.', 'is-error');
        });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-free-gift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-free-gift]').forEach(initClothingFreeGift);
  });

  function initClothingFreeGift(card) {
    var root = card.closest('[data-section-type="clothing-pdp"]');
    if (!root) return;

    var mapEl = card.querySelector('[data-gift-map]');
    var giftMap = mapEl ? JSON.parse(mapEl.textContent) : {};

    function render(gift) {
      if (!gift) {
        card.style.display = 'none';
        return;
      }
      card.style.display = '';
      var title = card.querySelector('.cl-pdp-gift__product-title');
      var worth = card.querySelector('.cl-pdp-gift__worth');
      var img = card.querySelector('.cl-pdp-gift__img');
      if (title) title.textContent = gift.title;
      if (worth) worth.textContent = 'worth ' + (window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(gift.price) : gift.price);
      if (img && gift.image) img.src = gift.image;
      card.dataset.currentGiftId = gift.id;
    }

    root.addEventListener('clothing-pdp:variant-change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;
      render(giftMap[variant.id]);
    });

    var atcBtn = root.querySelector('[data-atc-trigger]');
    var giftBtn = card.querySelector('[data-free-gift-atc]');
    if (giftBtn) {
      giftBtn.addEventListener('click', function () {
        var giftId = card.dataset.currentGiftId;
        var mainVariantId = atcBtn ? atcBtn.dataset.variantId : null;
        if (!giftId || !mainVariantId) return;
        var items = [{ id: mainVariantId, quantity: 1 }, { id: giftId, quantity: 1 }];
        window.clothingPdpAddToCartAjax(root, items);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;

    var code = btn.dataset.copyCode;
    var originalHtml = btn.innerHTML;

    function done(success) {
      btn.innerHTML = success ? code + ' <span>Copied</span>' : originalHtml;
      setTimeout(function () {
        btn.innerHTML = originalHtml;
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }).catch(function () { done(false); });
    } else {
      var textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        done(true);
      } catch (e) {
        done(false);
      }
      document.body.removeChild(textarea);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-offers').forEach(initClothingOffersDots);
  });

  function initClothingOffersDots(root) {
    var row = root.querySelector('[data-offers-row]');
    var dotsWrap = root.querySelector('[data-offers-dots]');
    if (!row || !dotsWrap) return;

    var cards = row.querySelectorAll('[data-offer-card]');
    var dots = dotsWrap.querySelectorAll('.cl-pdp-offers__dot');
    if (!cards.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, idx) {
        var active = idx === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10);
        var card = cards[index];
        if (!card) return;
        row.scrollTo({ left: card.offsetLeft - row.offsetLeft, behavior: 'smooth' });
      });
    });

    var scrollTimeout;
    row.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var scrollLeft = row.scrollLeft;
          var closestIndex = 0;
          var closestDistance = Infinity;
          cards.forEach(function (card, i) {
            var distance = Math.abs(card.offsetLeft - row.offsetLeft - scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = i;
            }
          });
          setActive(closestIndex);
        }, 100);
      },
      { passive: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(function (root) {
      root.addEventListener('clothing-pdp:variant-change', function (e) {
        var variant = e.detail.variant;
        if (!variant) return;
        root.querySelectorAll('[data-variant-price]').forEach(function (el) {
          el.textContent = window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(variant.price) : variant.price;
        });
        root.querySelectorAll('[data-variant-compare-price]').forEach(function (el) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(variant.compare_at_price) : variant.compare_at_price;
            el.classList.remove('is-hidden');
          } else {
            el.classList.add('is-hidden');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-sku"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(function (root) {
      root.addEventListener('clothing-pdp:variant-change', function (e) {
        var variant = e.detail.variant;
        if (!variant) return;
        root.querySelectorAll('[data-variant-sku]').forEach(function (el) {
          el.textContent = variant.sku || '';
          var wrap = el.closest('.cl-pdp-sku');
          if (wrap) wrap.hidden = !variant.sku;
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-trust-badges"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-trust-badges]').forEach(initClothingTrustBadges);
  });

  function initClothingTrustBadges(trustBadges) {
    var root = trustBadges.closest('[data-section-type="clothing-pdp"]');
    if (!root) return;

    var cell = trustBadges.querySelector('[data-trust-badge-2]');
    var icon = trustBadges.querySelector('[data-trust-badge-2-icon]');
    var text = trustBadges.querySelector('[data-trust-badge-2-text]');
    if (!cell || !icon || !text) return;

    var defaultText = cell.dataset.badge2DefaultText || '15-Day Exchange & Return';
    var defaultIcon = '↺';

    root.addEventListener('clothing-pdp:variant-change', function (e) {
      var variant = e.detail.variant;
      var isRefundable = !(variant && variant.refundable === false);

      icon.textContent = isRefundable ? defaultIcon : '🚫';
      text.textContent = isRefundable ? defaultText : 'No Return, No Exchange';
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-variant-picker]').forEach(initClothingVariantPicker);
  });

  // Called by the buy-buttons block when "Add to bag" is clicked with no
  // size chosen yet.
  window.clothingPdpFlagSizeError = window.clothingPdpFlagSizeError || function (root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (picker && picker._flagSizeError) picker._flagSizeError();
  };

  // Called by the sticky bar when its Add to bag is clicked with no size
  // chosen yet — opens the mobile-style "Select Size" bottom sheet.
  window.clothingPdpOpenSizeSheet = window.clothingPdpOpenSizeSheet || function (root) {
    var sheet = root.querySelector('[data-size-sheet]');
    if (sheet && sheet._open) sheet._open();
  };

  function initClothingVariantPicker(picker) {
    var root = picker.closest('[data-section-type="clothing-pdp"]');
    if (!root) return;

    var jsonEl = picker.querySelector('[data-variant-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    var refundableEl = picker.querySelector('[data-variant-refundable-map]');
    var refundableMap = refundableEl ? JSON.parse(refundableEl.textContent) : {};

    var sizeRequired = picker.dataset.sizeRequired === 'true';
    var sizePosition = picker.dataset.sizePosition;
    // Nothing to pick when there's only one size (or no size option at all) —
    // treat it as already satisfied. Otherwise the shopper must actively tap
    // a size chip before Add to bag will go through.
    // Also already satisfied when the page loaded with an explicit
    // "?variant=<id>" in the URL — see data-size-preselected in the markup.
    var sizeChosen = !sizeRequired || picker.dataset.sizePreselected === 'true';

    var selected = {};

    variants.forEach(function (v) {
      v.options.forEach(function (opt, i) {
        var position = i + 1;
        // Leave the size position unfilled so nothing reads as pre-selected —
        // every other option (e.g. colour) still defaults to the first value.
        if (sizeRequired && String(position) === String(sizePosition)) return;
        if (!selected[position]) selected[position] = opt;
      });
    });

    picker.querySelectorAll('.cl-swatch.is-selected, .cl-chip.is-selected').forEach(function (el) {
      selected[el.dataset.optionPosition] = el.dataset.optionValue;
    });

    function updateSizeState() {
      root.dataset.sizeRequired = sizeRequired ? 'true' : 'false';
      root.dataset.sizeSelected = sizeChosen ? 'true' : 'false';
    }
    updateSizeState();

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i + 1] === undefined || selected[i + 1] === opt;
        });
      });
    }

    function emit(variant) {
      if (variant) {
        variant.refundable = refundableMap[variant.id];
      }
      root.dispatchEvent(new CustomEvent('clothing-pdp:variant-change', { detail: { variant: variant } }));
    }

    function clearSizeError() {
      var group = picker.querySelector('.cl-pdp-variant__group.is-size-error');
      if (group) group.classList.remove('is-size-error');
    }

    picker._flagSizeError = function () {
      var sizesWrap = picker.querySelector('.cl-pdp-variant__sizes');
      var group = sizesWrap ? sizesWrap.closest('.cl-pdp-variant__group') : null;
      if (group) {
        group.classList.remove('is-size-error');
        void group.offsetWidth; // restart the shake animation on repeat clicks
        group.classList.add('is-size-error');
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (window.clothingPdpToast) window.clothingPdpToast(root, 'Please select a size');
    };

    picker.addEventListener('click', function (e) {
      var el = e.target.closest('.cl-swatch, .cl-chip');
      if (!el || el.classList.contains('is-soldout')) return;
      // Connected-product size pills are plain links — let them navigate.
      if (el.classList.contains('cl-chip--link')) return;

      var position = el.dataset.optionPosition;
      selected[position] = el.dataset.optionValue;

      picker.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (sib) {
        sib.classList.remove('is-selected');
      });
      el.classList.add('is-selected');

      var colorName = picker.querySelector('[data-color-name]');
      if (colorName && el.classList.contains('cl-swatch')) {
        colorName.textContent = '— ' + el.dataset.optionValue;
      }

      if (sizeRequired && String(position) === String(sizePosition)) {
        sizeChosen = true;
        updateSizeState();
        clearSizeError();
      }

      var variant = findVariant();
      if (variant) emit(variant);
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-size-chart-popup]')) {
        var popup = document.querySelector('[data-size-guide-popup]') || document.getElementById('SizeGuidePopup');
        if (popup) popup.classList.add('is-open');
      }
      // "Size Chart" (data-jump-to-tab="size-fit") is handled generically by
      // initGallery()'s [data-jump-to-tab] listener in clothing-pdp.liquid,
      // which dispatches clothing-pdp:open-tab — the same mechanism the
      // rating badge uses to jump to the reviews tab.
    });

    initSizeSheet(root, picker);
  }

  // The bottom sheet shown when the sticky Add to bag is tapped with no size
  // chosen — mirrors the chips already rendered in the page's own size row,
  // so picking one there drives the exact same selection logic (by clicking
  // the real, non-cloned chip) rather than duplicating it.
  function initSizeSheet(root, picker) {
    var sheet = root.querySelector('[data-size-sheet]');
    if (!sheet) return;

    var sizesWrap = picker.querySelector('.cl-pdp-variant__sizes');
    var sheetSizes = sheet.querySelector('[data-size-sheet-sizes]');
    var doneBtn = sheet.querySelector('[data-size-sheet-done]');
    var chosenClone = null;

    function populate() {
      if (!sizesWrap || !sheetSizes) return;
      sheetSizes.innerHTML = '';
      chosenClone = null;
      if (doneBtn) doneBtn.disabled = true;
      Array.prototype.forEach.call(sizesWrap.children, function (node) {
        var clone = node.cloneNode(true);
        clone.classList.remove('is-selected');
        sheetSizes.appendChild(clone);
      });
    }

    sheet._open = function () {
      populate();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    function close() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-sheet-close]')) {
        close();
        return;
      }

      var chip = e.target.closest('.cl-chip');
      if (chip && sheetSizes.contains(chip) && !chip.classList.contains('is-soldout') && !chip.classList.contains('cl-chip--link')) {
        sheetSizes.querySelectorAll('.cl-chip').forEach(function (c) { c.classList.remove('is-selected'); });
        chip.classList.add('is-selected');
        chosenClone = chip;
        if (doneBtn) doneBtn.disabled = false;
        return;
      }

      if (e.target.closest('[data-size-sheet-done]')) {
        if (!chosenClone) return;
        var position = chosenClone.dataset.optionPosition;
        var value = chosenClone.dataset.optionValue;
        var realChip = null;
        picker.querySelectorAll('.cl-chip[data-option-position="' + position + '"]').forEach(function (candidate) {
          if (candidate.dataset.optionValue === value) realChip = candidate;
        });
        close();
        if (realChip) realChip.click();
        var atcBtn = root.querySelector('[data-atc-trigger]');
        if (atcBtn) atcBtn.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
